import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ButtonSize,
  ButtonState,
  ButtonType,
  InputSize,
  InputState,
  IEducation,
} from '../../../assets/types/dtoTypes';
import {InputComponent} from "../../shared/input/input.component";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";
import {ButtonComponent} from "../../shared/button/button.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-education-manager',
  templateUrl: './education-manager.component.html',
  standalone: true,
  imports: [
    InputComponent,
    TranslateModule,
    FormsModule,
    ButtonComponent,
    NgIf
  ],
  styleUrls: ['./education-manager.component.scss']
})
export class EducationManagerComponent {
  dialogRef = inject<MatDialogRef<EducationManagerComponent>>(MatDialogRef);
  data = inject<IEducation>(MAT_DIALOG_DATA);

  education: IEducation;

  isInvalid: boolean = true;

  validationErrors = {
    requiredFields: false,
    startDateFuture: false,
    invalidRange: false,
  };


  constructor() {
    const data = this.data;

    this.education = { ...data };
    this.validateForm();
  }

  onInputChange(): void {
    this.validateForm();
  }

  validateForm(): void {
    const { education, organization, location, startDate } = this.education;
    const endDate = this.education.completionDate;

    const allFieldsFilled = education && organization && location && startDate;



    const now = new Date();
    const start = new Date( startDate );
    const end = endDate ? new Date( endDate ) : null;

    const isStartValid = start.getTime() < now.getTime();
    const isRangeValid = !end || start.getTime() < end.getTime();

    this.validationErrors.requiredFields = !allFieldsFilled;
    this.validationErrors.startDateFuture = allFieldsFilled && !isStartValid;
    this.validationErrors.invalidRange = allFieldsFilled && !isRangeValid;

    this.isInvalid = !( allFieldsFilled && isStartValid && isRangeValid );
  }

  save() {
    if ( !this.isInvalid ) {
      this.dialogRef.close( this.education );
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  protected readonly ButtonType = ButtonType;

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly InputState = InputState;

  protected readonly InputSize = InputSize;
}
